






import Vue from 'vue'

import types from '../../store/types'
import {Shape} from '../../interface'

export default Vue.extend({

  computed: {
    styleObject(): any {
      const shapeIndex: number = this.$store.state.Current.shape
      const shapeList: Shape[] = this.$store.state.Shape.list

      if (! shapeList[shapeIndex]) {
        return {}
      }
      const shapeInfo: Shape = shapeList[shapeIndex]

      return {
        'background-image': 'url(' + shapeInfo.line + ')'
      }
    }
  }

})
